<template>
    <div class="articles">
        <div class="articlesSite"><router-link to="/">首页</router-link><em>/</em>动态资讯</div>
        <div class="articlesTitle">{{newDetails.title}}</div>
        <div class="articlesContent">
            <pre class="text">{{newDetails.content}}</pre>
            <img v-for="item in newDetails.img" :src="item" alt="" />
        </div>
    </div>
</template>

<script>
    import { articlesList } from '../json/articles';
    export default {
        name:'articles',
        data() {
            return {
                newDetails: {},
            }
        },
        mounted(){
            if(this.$route.params.id != undefined){
                this.newDetails = articlesList[this.$route.params.id-1];
            }
        },
        methods:{},
        
    }
</script>

<style lang="scss" scoped>
    .articles{
        width:$navWidth;
        margin:20px auto ;
        padding:20px;
        @include h-bgColor(var(--colorFF));
        .articlesSite{
            @include h-fontSize(var(--colorF6),14px,30px);
            a{  
                color:$colorF6;
                &:hover{
                    color:$colorE7;
                }
            }
            em{
                margin:0 4px;
            }
        }
        .articlesTitle{
            margin:16px 0 0;
            text-align: center;
            font-weight: bold;
            user-select: text;
            @include h-fontSize(var(--color22),24px,32px);
        }
        .articlesContent{
            margin:30px 0 0;
            user-select: text;
            white-space: pre-wrap;
            word-wrap: break-word;
            @include h-fontSize($color66,16px,32px);
            p,
            span,
            i,
            em,
            pre,
            .text{
                white-space: pre-wrap;
                word-wrap: break-word;
                font-family: PingHei, "Helvetica Neue", Helvetica, "microsoft yahei";
            }
            img{
                width: auto;
                max-width:90%;
                margin:20px auto;
            }
        }
    }
</style>